module.exports = __webpack_public_path__ + "static/media/R3.5c52852d.jpg";